import kalog from "@provis/provis-common-be-module/dist/constants/claim/kalog";

const formatDocKalog = (docType) => {
    return kalog?.LIST_DESC[docType]?.id || "Deskripsi tidak ditemukan";
};

export default formatDocKalog